<router-outlet></router-outlet>
<div class="progress-spinner"
     *ngIf="common.loader">
  <div class="spinner-border"
       role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>